
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.667 1.08a5.5 5.5 0 00-3.3 1.1L0 4.705 3.367 7.23a5.5 5.5 0 003.3 1.1h1a5.5 5.5 0 003.3-1.1l3.366-2.525-3.366-2.525a5.5 5.5 0 00-3.3-1.1h-1zm3.5 3.625a3 3 0 11-6 0 3 3 0 016 0z","fill":"#fff"}})])
          )
        }
      }
    